import { useState, useEffect, useContext } from "react";
import { useSession } from "next-auth/client";
import { Text, Center, Box, Button, useColorModeValue,
  Flex,
  Link,
} from "@chakra-ui/react";
import PuffLoader from "react-spinners/PuffLoader";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { firebaseClient } from "firebaseClient";
import { getAccount } from "utils/sessionHelper";
import { isTweetFromAccount } from "controllers/schedule";
import { TweetContext } from "context/tweetContext";
import { TweetBar } from "./tweet-bar";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { useStats } from "hooks/useStats";
import * as analytics from "utils/analytics";

interface Props {
  isSelected: boolean;
}

export function ClientPanel({ isSelected }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [drafts, setDrafts] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [hasFetched, setHasFetched] = useState<boolean>(false);
  const isAuthenticated = useFirebaseUser();
  const tweetContext: any = useContext(TweetContext);
  const [session] = useSession();
  const tweetbarBg = useColorModeValue("blue.50", "blue.900");
  const threadBg = useColorModeValue("purple.100", "purple.700");
  const { updateStatsCounter } = useStats();

  useEffect(() => {
    // console.log("ghost panel useEffect");
    if (isAuthenticated && isSelected && !hasFetched) {
      setHasFetched(true);
      loadDrafts();
      updateStatsCounter("visit_queue_ghostwriters");
      analytics.log("visit_queue_ghostwriters");
    } else {
      getDrafts();
    }
  }, [isAuthenticated, tweetContext.refresh, isSelected]);

  const loadDrafts = async () => {
    setIsLoading(true);
    await getDrafts();
    setIsLoading(false);
  }

  const getDrafts = async (type?: "loadMore") => {
    
    console.log("getDrafts for ID " + getAccount(session)?.id);
    
    if (!isAuthenticated) {
      return;
    }

    let draftsCopy = [] as any;
    const db = firebaseClient.firestore();

    let docs = await db
      .collection("users")
      .doc(getAccount(session).id)
      .collection("tweets")
      .where("status", "==", "ghost")
      .where("idAccount", "==", getAccount(session).idAccount)
      .orderBy("dateCreated", "desc")
      .get();

    docs.forEach((doc) => {
      const data = doc.data();
      draftsCopy.push(data);
    });

    draftsCopy.forEach(tw => {
      if (tw.statusGhost === "pending") tw.priority = 3;
      else if (tw.statusGhost === "rejected") tw.priority = 1;
      else if (tw.statusGhost === "done") tw.priority = 0;
      else tw.priority = 2;
    });

    // sort by statusGhost
    draftsCopy = draftsCopy.sort((a, b) => b.priority - a.priority);
    // console.log('draftsCopy:', draftsCopy)
    // draftsCopy = [];

    setDrafts(draftsCopy);
  };

  const onDelete = async (docId: string) => {
    const filteredDrafts = drafts.filter((d) => d.id !== docId);
    setDrafts(filteredDrafts);
  };

  const loadMoreDrafts = async () => {
    if (!isAuthenticated) {
      return;
    }

    setIsLoadingMore(true);
    await getDrafts("loadMore");
    setIsLoadingMore(false);
  }

  if (isLoading) {
    return (
      <Center mt="40">
        <PuffLoader
          color={"hsl(203, 100%, 36%)"}
          loading={isLoading}
          css="display: block; margin: 0 auto; border-color: red;"
          size={50}
        />
      </Center>
    );
  }

  if (!isLoading && drafts?.length === 0) {
    return (
      <Center mt="44">
        <Box textAlign="center">
          <Text mb={4} fontWeight={600}
          textStyle="h2.bold.standard"
          >No tweets pushed by Ghostwriters</Text>
          {
            getAccount(session)?.id === getAccount(session)?.idAccount ? (
              <Text 
          textStyle="body.medium.light"
              mt={4}>Share your custom link to ghostwriters so they can write for you</Text>
            ) : (
              <Text 
          textStyle="body.medium.light"
              mt={4}>Custom links are not available for sub-accounts</Text>
            )
          }
          <CopyToClipboard
              text={"https://tweethunter.io/write?handle=" + getAccount(session)?.twUserName}
              onCopy={() => {
                toast.success("Link copied to clipboard");
              }}
          >
              <Button mt={5} variant={"primary"} isDisabled={getAccount(session)?.id !== getAccount(session)?.idAccount}>
                  Share Custom Link
              </Button>
          </CopyToClipboard>
        </Box>
      </Center>
    );
  }

  return (
    <Box>
      
      {
        // (session?.user?.data?.isAdmin) && (
        true && (
            <Flex justifyContent="flex-end" alignItems="center" w="100%" mt="0" pb={0}>
                <Flex>
                    <Button
                        variant={"secondary"}
                        // size="sm"
                        as={Link}
                        href="https://tweethunter.io/marketplace"
                        target="_blank"
                    >
                        Find ghostwriters (beta)
                    </Button>
                </Flex>
            </Flex>
        )
      }
      <Flex alignItems="center" mt="7" pb={4}>
        <Text textStyle="h4.bold.standard">
          Drafts written by Ghostwriters
        </Text>
        <CopyToClipboard
            text={"https://tweethunter.io/write?handle=" + getAccount(session)?.twUserName}
            onCopy={() => {
              toast.success("Link copied to clipboard");
            }}
        >
            <Button ml={5} variant={"secondary"} colorScheme="gray">
                Share Custom Link
            </Button>
        </CopyToClipboard>
      </Flex>
      {drafts.map((draft) => (
        <TweetBar
          key={draft.id}
          type="ghost"
          tweet={draft}
          // bg={tweetbarBg}
          // threadBg={threadBg}
          onDelete={onDelete}
          disableIcon={true}
        />
      ))}
      {drafts?.length > 0 && hasMore && (
        <Box textAlign="center" mt="16">
          <Button
            size="sm"
            variant="secondary"
            onClick={loadMoreDrafts}
            isLoading={isLoadingMore}
          >
            Load more
          </Button>
        </Box>
      )}
    </Box>
  );
}
